<template>
<div id="main" class="column is-9">
			<Spinner size="huge" v-if="!idle"></Spinner>
			<section class="approvals" v-if="idle">
			<div class="columns">
				<div class="column">
					<router-link to="/Newpsychic" class="button is-link add-psychic is-small"><i class="fa fa-plus"></i>&nbsp;Psychic</router-link>
					<h1>Approvals</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							<strong>Approvals Waiting</strong>
						</p>
						</header>
						<div class="card-table">
							<div class="content">
								<table class="table is-fullwidth is-striped">
								<thead>
								<tr>
									<th>
										Date
									</th>
									<th>
										Agent
									</th>
									<th>
										Type
									</th>
									<th>
										&nbsp;
									</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="psychic in approvals" :key="psychic.agent_user_id">
									<td>
										{{ formatDate(psychic.date) }}
									</td>
									<td>
										<router-link :to="'/psychics/' + psychic.agent_user_id">{{ psychic.agent_user_name }}</router-link>
									</td>
									<td>
										{{ psychic.to_approve }}
									</td>
								</tr>
								</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			</section>
		</div>
</template>

<script>
	import moment from "moment-timezone"
	import Spinner from 'vue-simple-spinner'

	export default {
		components: {
			Spinner,
		},
		data() {
			return {
				approvals: [],
				idle: false,
			}
		},
		methods: {
			formatDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY")
			}
		},
		async created() {
			this.approvals = await this.$root.$data.getters.getApprovals(this.$root.$data.state)
			this.idle = true
		}
	}
</script>